<template>
  <detail-layout-full-width>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
        >
        <div class="lg:max-w-detail lg:mr-auto">
          
          <div class="lg:mb-2">
            <div class="mandatory">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('hotfolder.server')}}
                <el-form-item prop="server">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.server"
                    maxlength='200'
                  />
                </el-form-item>
              </label>
            </div>
          </div>

          <div class="lg:mb-2">
            <div class="mandatory">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('hotfolder.port')}}
                <el-form-item prop="port">
                  <el-input
                    clearable
                    class="w-full"
                    v-model.number="form.port"
                    maxlength='10'
                  />
                </el-form-item>
              </label>
            </div>
          </div>

          <div class="mb-4">
            <label for="switch-ssl" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
              {{$t('hotfolder.ssl')}}
              <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('companies.active')}}</span>
            </label>
            <el-switch 
              id="switch-ssl"
              :aria-label="$t('hotfolder.ssl')"
              class="switch-text break-normal both-switch mt-2" 
              v-model="form.ssl" 
              :active-text="$t('companies.active')"/>
          </div>

          <div class="mb-4">
            <label for="switch-oauth2" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
              {{$t('hotfolder.oauth2')}}
              <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('companies.active')}}</span>
            </label>
            <el-switch 
              id="switch-oauth2"
              :aria-label="$t('hotfolder.oauth2')"
              class="switch-text break-normal both-switch mt-2" 
              v-model="form.oauth2" 
              :active-text="$t('companies.active')"/>
          </div>

          <div class="lg:mb-2" v-if="form.oauth2">
            <div class="mandatory">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('smtp.clientid')}}
                <el-form-item prop="clientid">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.clientid"
                    maxlength='100'
                  />
                </el-form-item>
              </label>
            </div>
          </div>

          <div class="lg:mb-2" v-if="form.oauth2">
            <div class="mandatory">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('smtp.tenantid')}}
                <el-form-item prop="tenantid">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.tenantid"
                    maxlength='100'
                  />
                </el-form-item>
              </label>
            </div>
          </div>

          <div class="lg:mb-2">
            <div class="mandatory">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('hotfolder.user')}}
                <el-form-item prop="user">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.user"
                    maxlength='100'
                  />
                </el-form-item>
              </label>
            </div>
          </div>

          <div class="lg:mb-2">
            <div class="mandatory">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="!form.oauth2"/>{{$t('hotfolder.pass')}}
                <el-form-item prop="pass">
                  <el-input
                    ref="passwordInputHotFolderPass"
                    :disabled="disableEditPass"
                    clearable
                    show-password
                    class="w-full"
                    v-model="form.pass"
                    autocomplete="new-password"
                    maxlength='100'
                  >
                    <base-button-icon
                      v-if="visibleEditPass"
                      slot="append" 
                      @click="editPassToggle()"
                      :name="disableEditPass ? 'editpencil' : 'cross'"
                      :ariaLabel="disableEditPass ? 'Editar contraseña' : 'Cancelar edición de contraseña'"
                      iconSize="md"
                      size="xs"
                      mode="primary-phantom"
                      class="bg-primary-100 hover:bg-primary-200 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full"
                    />
                  </el-input>
                </el-form-item>
              </label>
            </div>
          </div>

          <div class="lg:mb-2" v-if="form.oauth2">
            <div class="mandatory">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('hotfolder.secret')}}
                <el-form-item prop="secret">
                  <el-input
                    ref="passwordInputHotFolderSecret"
                    :disabled="disableEditPassSecret"
                    clearable
                    show-password
                    class="w-full"
                    v-model="form.secret"
                    autocomplete="new-password"
                    maxlength='100'
                  >
                    <base-button-icon
                      v-if="visibleEditPassSecret"
                      slot="append" 
                      @click="editPassSecretToggle()"
                      :name="disableEditPassSecret ? 'editpencil' : 'cross'"
                      :ariaLabel="disableEditPassSecret ? 'Editar secreto' : 'Cancelar edición de secreto'"
                      iconSize="md"
                      size="xs"
                      mode="primary-phantom"
                      class="bg-primary-100 hover:bg-primary-200 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full"
                    />
                  </el-input>
                </el-form-item>
              </label>
            </div>
          </div>
          
          <div class="mb-2">
            <div class="text-sm font-semibold text-secondary-600 block flex flex-col">
                {{$t('hotfolder.extract_metadatas')}}
              <div class="flex flex-col lg:flex-row gap-x-6 mt-2">
                <label for="switch-metadato-to" class="sr-only">
                  {{$t('hotfolder.MetadatoTo')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('companies.active')}}
                </label>
                <el-switch 
                  id="switch-metadato-to"
                  :aria-label="$t('hotfolder.MetadatoTo')"
                  class="switch-text break-normal mb-2" 
                  v-model="form.MetadatoTo" 
                  :active-text="$t('hotfolder.MetadatoTo')">
                </el-switch>
                <label for="switch-metadato-cc" class="sr-only">
                  {{$t('hotfolder.MetadatoCC')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('companies.active')}}
                </label>
                <el-switch 
                  id="switch-metadato-cc"
                  :aria-label="$t('hotfolder.MetadatoCC')"
                  class="switch-text break-normal mb-2" 
                  v-model="form.MetadatoCC" 
                  :active-text="$t('hotfolder.MetadatoCC')">
                </el-switch>
                <label for="switch-metadato-from" class="sr-only">
                  {{$t('hotfolder.MetadatoFrom')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('companies.active')}}
                </label>
                <el-switch 
                  id="switch-metadato-from"
                  :aria-label="$t('hotfolder.MetadatoFrom')"
                  class="switch-text break-normal mb-2" 
                  v-model="form.MetadatoFrom" 
                  :active-text="$t('hotfolder.MetadatoFrom')">
                </el-switch>
              </div>
            </div>
          </div>

          <div class="mb-4">
            <label for="switch-solo-no-leidos" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
              <div class="flex items-center">
                {{$t('hotfolder.soloNoLeidos')}}
                <base-tooltip-icon size="sm" :content="$t('hotfolder.soloNoLeidos_tooltip')" class="ml-2"/>
              </div>
              <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('companies.active')}}</span>
            </label>
            <el-switch 
              id="switch-solo-no-leidos"
              :aria-label="$t('hotfolder.soloNoLeidos')"
              class="switch-text break-normal both-switch mt-2" 
              v-model="form.soloNoLeidos" 
              :active-text="$t('companies.active')"/>
            
          </div>

          <div class="mb-8">
            <label for="switch-activo" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
              {{$t('hotfolder.Activo')}}
              <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('companies.active')}}</span>
            </label>
            <el-switch 
              id="switch-activo"
              :aria-label="$t('hotfolder.Activo')"
              class="switch-text break-normal both-switch mt-2" 
              v-model="form.Activo" 
              :active-text="$t('companies.active')"/>
          </div>

          <div class="mb-2" v-if="form.UltimaVigilanciaCorrecta">
            <base-ro-input :label="$t('hotfolder.UltimaVigilanciaCorrecta')" :data="form.UltimaVigilanciaCorrecta"/>
          </div>

          <div class="mb-2" v-if="form.Error">
            <base-ro-input :label="$t('hotfolder.Error')" :data="form.Error"/>
          </div>

        </div>
        </el-form>
      </div>
      </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="$t('app.cancel')" icon="cross" @click="goBack" :loading="isGeneralLoading"/>
          <base-button-responsive mode="primary" v-if="showTestHotFolder" :text="$t('hotfolder.test_btn')" icon="mailtest" @click="submitForm('ruleForm', true)" :loading="isGeneralLoading" :disabled="isGeneralLoading"/>
          <base-button-responsive mode="primary" :text="$t('app.save')" icon="save" @click="submitForm('ruleForm')" :loading="isGeneralLoading" :disabled="isGeneralLoading"/>
        </template>
      </base-footer>
    </template>
  </detail-layout-full-width>
</template>

<script>
import moment from 'moment'

import DetailLayoutFullWidth from '../../components/layout/DetailLayoutFullWidth.vue'
import { getHotfolder } from '@/services/clients/getHotfolder'
import { updateHotfolder } from '@/services/clients/updateHotfolder' 
import { probarcifempresaconfigcorreo } from '@/services/clients/probarcifempresaconfigcorreo' 
import { i18n } from '@/i18n'

import { getCompany } from '@/services/companies/getCompany'

function isValidNum (value) {
  if (Number.isInteger(parseFloat(value))) {
    if (value >= 0 && value <= 999999) {
      return true
    }
  }
  return false
}


export default {
  /* eslint-disable camelcase */
  name: 'hot-folder-companies',
  components: {
    DetailLayoutFullWidth,
  },
  data: function () {
    return {
      activeName: 'es',
      header: {
        title: i18n.t('hotfolder.title_lg'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'companies/detail',
      },
      showTestHotFolder: false,

      visibleEditPass: true,
      disableEditPass: true,
      visibleEditPassSecret: true,
      disableEditPassSecret: true,

      form: {
        server: '',
        port: '',
        ssl: false,
        oauth2: false,
        clientid: '',
        tenantid: '',
        user: '',
        pass: '',
        secret: '',
        soloNoLeidos: true,
        Activo: false,
        MetadatoTo: false,
        MetadatoCC: false,
        MetadatoFrom: false,
        UltimaVigilanciaCorrecta: '',
        Error: '',
      },
      rules: {
        server: [
          { validator: this.isGenericValidation, trigger: 'blur' },
        ],
        port: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { required: true, validator: this.isNumberValid, trigger: 'blur' }
        ],
        clientid: [
          { validator: this.isGenericValidation, trigger: 'blur' },
        ],
        tenantid: [
          { validator: this.isGenericValidation, trigger: 'blur' },
        ],
        user: [
          { validator: this.isGenericValidation, trigger: 'blur' },
        ],
        pass: [
          { required: true, validator: this.isPasswordValid, trigger: 'blur' }
        ],
      }
    }
  },
  computed: {
    isOAuth2Disabled () {
      return !this.form?.oauth2
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    id () {
      return this.$route.params.id ? this.$route.params.id : -1
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    'form.oauth2': function (value, oldValue) {
      if (this.form.oauth2) this.fixAccesibilityElSecret()
    }
  },
  created: async function () {
    const breadcrumbs = []
    
    breadcrumbs.push({ path: 'companies', name: this.$i18n.t('app.companies') })
    if (this.id !== -1) {
      if (this.$store.getters['app/fromRouteName'] !== null) {
        const breadcrumbHeader = this.$store.getters['app/headerBreadCrumb']
        breadcrumbs.push({ path: '', name: breadcrumbHeader })
      } else {
        const company = await this.downloadCompanyData(this.id)
        breadcrumbs.push({ path: '', name: company.NombreCIF })
        this.$store.commit('app/setheaderBreadCrumb', company.NombreCIF)
      }
    }

    this.header.breadcrumb = breadcrumbs

    const data = await this.downloadData(this.id)
    this.setData(data.respuesta)
  },
  mounted () {
    this.resetControlFormChanges()
    this.fixAccesibilityElPass()
    this.fixAccesibilityElSecret()
  },
  methods: {
    fixAccesibilityElPass () {
      this.$nextTick(() => {
      // Timeout para esperar a que se rendericen los iconos
        setTimeout(() => {
          this.fixAccesibilityElInputPassword(this.$refs.passwordInputHotFolderPass, this.$i18n.t('aria.elementui.input.password'))
        }, 1000)
      })
    },
    fixAccesibilityElSecret () {
      this.$nextTick(() => {
      // Timeout para esperar a que se rendericen los iconos
        setTimeout(() => {
          this.fixAccesibilityElInputPassword(this.$refs.passwordInputHotFolderSecret, this.$i18n.t('aria.elementui.input.password'))
        }, 1000)
      })
    },
    isPasswordValid: function (rule, value, callback) {
      if (this.isOAuth2Disabled) {
        if (!value || value === '') {
          return this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
        } 
      }
      callback()
    },
    editPassToggle () {
      if (this.disableEditPass) this.form.pass = ''
      else this.form.pass = '**********'
      this.disableEditPass = !this.disableEditPass
    },
    editPassSecretToggle () {
      if (this.disableEditPassSecret) this.form.secret = ''
      else this.form.secret = '**********'
      this.disableEditPassSecret = !this.disableEditPassSecret
    },
    toggleShowHidePass (disable = true) {
      this.form.pass = disable ? '**********' : ''
      this.disableEditPass = disable
      this.visibleEditPass = disable
    },
    toggleShowHidePassSecret (disable = true) {
      this.form.secret = disable ? '**********' : ''
      this.disableEditPassSecret = disable
      this.visibleEditPassSecret = disable
    },
    downloadCompanyData: async function (id) {
      try {
        this.$store.commit('setIsLoading', true)

        const params = { idCIFEmpresa: id }
        const company = await getCompany(params)
        return company.CIFSEmpresa[0]
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    watchFormHandler () {
      this.$store.commit('app/setFormChanges', true)
    },
    isNumberValid: function (rule, value, callback) {
      if (!value || value === '') {
        return this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
        // callback()
      } else if (!isValidNum(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.number'), callback)
      } else {
        callback()
      }
    },
    testHotFolder: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const res = await probarcifempresaconfigcorreo({ idCIFEmpresa: this.id })
        if (res.blnError) {
          this.doFeedback(res.msgError + ' [Código de error: ' + res.codError + ']')
        } else {
          this.doFeedback('Prueba realizada correctamente', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    submitForm: function (formName, test = false) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const payload = {
            idCIFEmpresa: this.id,
            Servidor: this.form.server,
            Puerto: this.form.port,
            SSL: this.form.ssl,
            ClientId: this.form.oauth2 ? this.form.clientid : null,
            TenantId: this.form.oauth2 ? this.form.tenantid : null,
            Usuario: this.form.user,
            Password: this.disableEditPass ? null : this.form.pass,
            TienePassword: !this.disableEditPass,
            SoloNoLeidas: this.form.soloNoLeidos,
            Activo: this.form.Activo,
            MetadatoTo: this.form.MetadatoTo,
            MetadatoCC: this.form.MetadatoCC,
            MetadatoFrom: this.form.MetadatoFrom,
            ClientSecret: this.disableEditPassSecret ? null : this.form.secret,
            TieneClientSecret: !this.disableEditPassSecret,
          }
          const response = await updateHotfolder(null, payload)
          if (response.blnError) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.showTestHotFolder = true
            this.doFeedback('Datos actualizados correctamente', 'success')
            this.resetControlFormChanges()
            if (test) {
              this.testHotFolder()
            }
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    goBack: function () {
      this.$router.push({ name: 'companies/details', params: this.id })
    },
    downloadData: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const template = await getHotfolder({ idCIFEmpresa: this.id })
        if (template.blnError) {
          this.doFeedback(template.msgError + ' [Código de error: ' + template.codError + ']')
        } else {
          return template
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
    setData: function (data) {
      if (data) {
        this.form.server = data.Servidor 
        this.form.port = data.Puerto 
        this.form.ssl = data.SSL 
        this.form.oauth2 = !(!data.ClientId && !data.TenantId)
        this.form.clientid = data.ClientId 
        this.form.tenantid = data.TenantId 
        this.form.user = data.Usuario 
        this.form.soloNoLeidos = data.SoloNoLeidas 
        this.form.Activo = data.Activo
        this.form.MetadatoTo = data.MetadatoTo
        this.form.MetadatoCC = data.MetadatoCC
        this.form.MetadatoFrom = data.MetadatoFrom
        this.form.UltimaVigilanciaCorrecta = data.UltimaVigilanciaCorrecta 
          ? moment(data.UltimaVigilanciaCorrecta).format('YYYY-MM-DD HH:mm') 
          : null
        this.form.Error = data.Error
        this.showTestHotFolder = true
        if (data.TienePassword) {
          this.form.pass = '**********'
          this.visibleEditPass = true
          this.disableEditPass = true
        } else {
          this.visibleEditPass = false
          this.disableEditPass = false
        }
        if (data.TieneClientSecret) {
          this.form.secret = '**********'
          this.visibleEditPassSecret = true
          this.disableEditPassSecret = true
        } else {
          this.visibleEditPassSecret = false
          this.disableEditPassSecret = false
        }
      } 
      this.resetControlFormChanges()
    }
  }

}
</script>

